import {
  isAddressInManualMode,
  isManualInputSwitchVisible,
  isSubsequentRequestRunning,
  PersonModel
} from '../../../../selectors/addressUnmodeled';
import Checkbox from '@mos-cat/checkbox';
import React, { ChangeEventHandler } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'dva';
import { i18n } from '../../../../helpers/i18n';
import { t } from '@lingui/macro';

interface StateProps {
  isManualInput: boolean;
  isVisible: boolean;
  disabled: boolean;
}

interface DispatchProps {
  toggleManualInput: ChangeEventHandler;
}

interface OwnProps {
  model: PersonModel;
}

type Props = OwnProps & StateProps & DispatchProps;

function AddressManualInputSwitch(props: Props): JSX.Element | null {
  if (!props.isVisible) return null;
  return (
    <div className="PguFormGrid__row AddressManualInputSwitch">
      <div className="PguFormGrid_col">
        <Checkbox
          checked={props.isManualInput}
          label={i18n._(t`Адреса нет в списке`)}
          onChange={props.toggleManualInput}
          value="1"
          disabled={props.disabled}
        />
      </div>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  isManualInput: isAddressInManualMode,
  isVisible: isManualInputSwitchVisible,
  disabled: isSubsequentRequestRunning
});

function mapDispatchToProps(dispatch, { model }): DispatchProps {
  return {
    toggleManualInput() {
      dispatch({ type: `${model}/address/toggle/manualInput` });
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressManualInputSwitch);
